import { GeneralResponse } from "./base-responses.model";
import { BaseParams } from "./base-requests.model";

export class UserRegisterEmailParams extends BaseParams {
  Email: string;

  constructor(email: string, authToken?: string, languageId?) {
    super(authToken, languageId);
    this.Email = email;
  }
}

export class UserRegisterEmailResponse extends GeneralResponse { }
